import LookUpService from "@/services/feature/lookUp.service";

export const lookUpApi = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    getCompensationPlan({ commit }, originationChannel) {
      return LookUpService.getCompensationPlan(originationChannel).then(
        (resp) => {
          commit("dummy", "LookUpService.getCompensationPlan - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummy", "LookUpService.getCompensationPlan - error");
          return Promise.reject(error.response);
        }
      );
    },
    getCountyList({ commit }) {
      return LookUpService.getCountyList().then(
        (resp) => {
          commit("dummy", "LookUpService.getCountyList - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummy", "LookUpService.getCountyList - error");
          return Promise.reject(error.response);
        }
      );
    },
    getMstCodeVM({ commit }, codeType) {
      return LookUpService.getMstCodeVM(codeType).then(
        (resp) => {
          commit("dummy", "getMstCodeVM - Success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummy", "getMstCodeVM - Error");
          return Promise.reject(
            (error.response && error.response.data) ||
              error.message ||
              error.toString()
          );
        }
      );
    },

    getLoanStatusPipeline({ commit }) {
      return LookUpService.getLoanStatusPipeline().then(
        (resp) => {
          commit("dummy");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummy");
          return Promise.reject(
            (error.response && error.response.data) ||
              error.message ||
              error.toString()
          );
        }
      );
    },

    getHashTableMstCode() {
      return LookUpService.getHashTableMstCode().then(
        (resp) => {
          return Promise.resolve(resp);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },

    getHashTableOrganization() {
      return LookUpService.getHashTableOrganization().then(
        (resp) => {
          return Promise.resolve(resp);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },

    getBrokerCompPlanByOrganizationId({ commit }, organizationId) {
      return LookUpService.getBrokerCompPlanByOrganizationId(
        organizationId
      ).then(
        (resp) => {
          commit("dummy", "getBrokerCompPlanByOrganizationId - Success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummy", "getBrokerCompPlanByOrganizationId - error");
          return Promise.reject(error.response);
        }
      );
    },

    getBrokerCompPlanByFileData({ commit }, fileData) {
      return LookUpService.getBrokerCompPlanByFileData(fileData).then(
        (resp) => {
          commit("dummy", "getBrokerCompPlanByFileData - Success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummy", "getBrokerCompPlanByFileData - error");
          return Promise.reject(error.response);
        }
      );
    },
  },
  mutations: {
    dummy(state, obj) {
      console.log(obj);
    },
  },
};
